import { Reducer } from 'redux';
import { PURGE } from 'redux-persist';
import { LearningMap, LearningMapState, LearningMapTypes } from './types';

const INITIAL_STATE: LearningMapState = {
    data: { currentLearningMap: (undefined as unknown) as LearningMap },
    historyLearningMapList: [],
    wordcloudCategories: [],
    loading: false,
    hasError: false,
    success: false,
    successOnSave: false,
    errorOnSave: false,
};

const reducer: Reducer<LearningMapState> = (state: LearningMapState = INITIAL_STATE, action) => {
    switch (action.type) {
        case PURGE:
            return { ...INITIAL_STATE };
        case LearningMapTypes.GET_CURRENT_LEARNING_MAP_REQUEST:
            return { ...state, loading: true, hasError: false, success: false };
        case LearningMapTypes.GET_CURRENT_LEARNING_MAP_SUCCESS:
            return { ...state, data: { currentLearningMap: action.payload }, loading: false, hasError: false, success: true };
        case LearningMapTypes.GET_CURRENT_LEARNING_MAP_FAILURE:
            return { ...state, loading: false, hasError: true, successOnSave: false, error: action.payload, success: false };
        case LearningMapTypes.SAVE_CURRENT_LEARNING_MAP_REQUEST:
            return { ...state, loading: true, hasError: false, successOnSave: false, errorOnSave: false };
        case LearningMapTypes.SAVE_CURRENT_LEARNING_MAP_SUCCESS:
            return { ...state, loading: false, hasError: false, successOnSave: true, errorOnSave: false };
        case LearningMapTypes.SAVE_CURRENT_LEARNING_MAP_FAILURE:
            return { ...state, loading: false, hasError: true, successOnSave: false, errorOnSave: true };
        case LearningMapTypes.SAVE_CURRENT_LEARNING_MAP_CLEAR:
            return { ...state, loading: false, hasError: false, successOnSave: false, errorOnSave: false };
        case LearningMapTypes.GET_HISTORY_LEARNING_MAP_REQUEST:
            return { ...state };
        case LearningMapTypes.GET_HISTORY_LEARNING_MAP_SUCCESS:
            return { ...state, historyLearningMapList: action.payload };
        case LearningMapTypes.GET_HISTORY_LEARNING_MAP_FAILURE:
            return { ...state };
        case LearningMapTypes.GET_WORDCLOUD_CATEGORIES_DATA_REQUEST:
            return { ...state, loading: true, hasError: false, success: false };
        case LearningMapTypes.GET_WORDCLOUD_CATEGORIES_DATA_SUCCESS:
            return { ...state, loading: false, hasError: false, success: true, wordcloudCategories: action.payload };
        case LearningMapTypes.GET_WORDCLOUD_CATEGORIES_DATA_FAILURE:
            return { ...state, loading: false, hasError: true, success: false };
        case LearningMapTypes.GET_WORDCLOUD_CATEGORIES_DATA_CLEAR:
            return { ...state, wordcloudCategories: [] };
        default:
            return state;
    }
};

export default reducer;
